import { formatLanguages, joinWithAnd, useRouter } from '@application/utils';
import { CountryCode } from '@gql/graphql';
import type { BreederGetWhatsappInfoQuery } from '@gql/graphql';
import type { WhatsappBreederDetails } from '@presentation/components';
import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import { useMemo } from 'react';

type Breeder = NonNullable<BreederGetWhatsappInfoQuery['findManyDogBreeder']>[number];

export const useFormatBreeder = (
  breeder: Breeder | undefined,
  filteredBreeds?: Breeder['breederBreeds'],
) => {
  const { language, translate } = useRouter();

  const formattedBreeder: WhatsappBreederDetails | undefined = useMemo(() => {
    if (!breeder) return;

    const breedNames =
      filteredBreeds
        ?.map((breederBreed) => {
          return (
            (breederBreed?.dogBreed?.translations ?? []).find((x) => x.language === language)
              ?.name ?? undefined
          );
        })
        .filter((x) => !!x) ?? [];

    let title = translate('breederDetails.header.titleEmpty');

    if (breedNames?.length && breeder?.account.address?.country) {
      const names = joinWithAnd(translate, breedNames ?? []);
      title = translate('breederDetails.header.title')
        .replaceAll('$breeds', names ?? '')
        .replaceAll(
          '$country',
          translate(`enum.country.${breeder?.account.address?.country ?? CountryCode.BE}`),
        );
    }

    const spokenLanguages = formatLanguages(language, breeder.spokenLanguages);

    return {
      title,
      avatar: breeder.profileImg ?? PLACEHOLDER_IMAGE_USER,
      location: breeder.account?.address?.city,
      spokenLanguages,
    } as WhatsappBreederDetails;
  }, [breeder, filteredBreeds, translate, language]);

  return {
    formattedBreeder,
  };
};
